import React from 'react';

function Link() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21"
    >
      <path d="M6.188 8.586l-1.8 1.801a3.938 3.938 0 005.569 5.57l2.399-2.402a3.938 3.938 0 00-1.087-6.336l-.769.769a1.313 1.313 0 00-.202.261 2.625 2.625 0 011.13 4.38l-2.398 2.4a2.626 2.626 0 11-3.714-3.715l1.04-1.04a5.273 5.273 0 01-.168-1.689v.001z"></path>
      <path d="M7.497 9.135l.22-.22c.324-.325.73-.56 1.175-.679.12-.445.354-.85.68-1.176l.22-.22a3.943 3.943 0 00-1.917.378 3.93 3.93 0 00-.378 1.916v.001z"></path>
      <path d="M8.644 6.132a3.937 3.937 0 001.087 6.337l1.017-1.019A2.624 2.624 0 019.572 7.06l2.398-2.4a2.627 2.627 0 013.714 3.715l-1.04 1.04c.147.55.203 1.122.168 1.688l1.8-1.8a3.938 3.938 0 10-5.569-5.57l-2.399 2.4z"></path>
      <path d="M13.125 12.469a3.924 3.924 0 00.378-1.916l-.22.219c-.324.326-.73.56-1.175.68-.12.445-.354.85-.68 1.176l-.22.219c.661.037 1.32-.093 1.917-.377v-.001z"></path>
    </svg>
  );
}

export default Link;
